module.exports = "<app-subheader></app-subheader>\n<app-contact-form-big></app-contact-form-big>\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/contactForm/contact-form.component.html
// module id = ../../../../../src/app/contactForm/contact-form.component.html
// module chunks = 0